import { Entity, Cartesian3, PropertyBag } from 'cesium';
import { Label as getLabelStyle, Polygon as getStyle, setEntityStyle } from '../renderer';

export default class Polygon extends Entity {
    constructor(options) {
        const { geometry, properties, style, position, label, ...other } = options;

        let props = {
            clampToGround: true,
            properties: new PropertyBag(properties),
            polygon: {
                clampToGround: true,
                hierarchy: Cartesian3.fromDegreesArray(geometry.flat(Infinity)),
                extrudedHeight: 0,
                ...getStyle({ ...style }),
            },
            ...other,
        };

        // 添加label
        if (label?.text && position) {
            props.position = Cartesian3.fromDegrees(...position);
            props.label = getLabelStyle(label);
        }

        super(props);

        this.geometry = geometry;
    }

    setGeometry(geometry) {
        this.polygon.hierarchy._value.positions.positions = Cartesian3.fromDegreesArray(
            geometry.flat(Infinity),
        );
    }

    setPosition(position) {
        this.position.setValue(Cartesian3.fromDegrees(...position));
    }

    setProperties(properties) {
        this.properties.setValue(new PropertyBag(properties));
        this.polygon.properties.setValue(new PropertyBag(properties));
    }

    getProperties() {
        return this.properties;
    }

    setLabel(label) {
        this.label.setValue(getLabelStyle(label));
    }

    setStyle(style) {
        setEntityStyle(this.polygon, getStyle({ ...style }));
    }
}
